export const defaultConfig = {
    baseURL: "/",
    headers: {
        "Content-Type": "application/json"
    }
};
